import React, { useState } from 'react';
import departmentService from 'ApiService/SuperAdmin/departmentService';
import Card from 'components/card';
import InputField from 'components/fields/InputField';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import ConfirmationModal from 'pages/Common/ConfirmationModal';

function AddDepartment() {
  const [departmentData, setDepartmentData] = useState({
    name: '',
  });

  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setDepartmentData({
      ...departmentData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const trimmedName = departmentData.name.trim();

    if (!trimmedName) {
      toast.error('Department name is required.');
      return;
    }

    setIsModalOpen(true);
  };

  const confirmCreation = async () => {
    setIsModalOpen(false);
    setLoading(true);

    try {
      const payload = {
        name: departmentData.name.trim(),
      };

      const response = await departmentService.createDepartment(payload);

      if (response.data?.success) {
        toast.success(response.data.message);
        setDepartmentData({ name: '' });

        // Optional redirect
        // navigate("/superadmin/departments");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error creating department');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Card extra="max-w-[405px] md:max-w-[510px] md:w-[510px] h-max mx-2.5 md:mx-auto mt-[50px] mb-auto py-2.5 px-4 md:!p-[50px] pt-8 md:pt-[50px]">
        <h3 className="mb-[10px] text-4xl font-bold text-gray-900 dark:text-white">
          Hello! Super Admin
          <br /> Create Department
        </h3>

        <p className="mb-4 ml-1 text-base text-gray-600">
          Enter Department Name
        </p>

        <InputField
          variant="auth"
          extra="mb-3"
          label="Department Name*"
          placeholder="eg. Computer Science"
          id="name"
          name="name"
          maxLength={50}
          type="text"
          onChange={handleChange}
          value={departmentData.name}
        />

        <button
          disabled={loading || isModalOpen}
          onClick={handleSubmit}
          className="mt-4 w-full rounded-xl bg-brand-500 py-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 disabled:opacity-60"
        >
          {loading ? 'Creating...' : 'Create Department'}
        </button>
      </Card>

      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={confirmCreation}
        title="Confirm Department Creation"
        message={`Are you sure you want to create the department "${departmentData.name.trim()}"?`}
        confirmText="Yes, Create"
        cancelText="Cancel"
        icon="info"
      />
    </>
  );
}

export default AddDepartment;
